module.exports = __webpack_public_path__ + "fonts/fa-v2-brands-400.6381ec23.ttf";